import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Button, Tooltip } from 'antd';
import { FileUnknownOutlined, PlusOutlined, MinusOutlined, FormOutlined, EyeOutlined, ReloadOutlined } from '@ant-design/icons';
import './GenericTable.css';

import uistate from '../../uistate';
import common from '../../../common';

class GenericTable extends Component {

    state = {
        selectedRowKeys: [],
    };
    label = (key) => {
        return common.getLabel(this.props.labels, 'core', 'GenericTable', key);
    }
    addClicked = () => {
        this.props.onAdd();
    }
    deleteClicked = () => {
        if (this.state.selectedRowKeys.length < 1 || this.props.data.length < 1) {
            alert(this.label("NoSelection"));
        } else {
            if (window.confirm(this.label("Confirm"))) {
                this.props.onDelete(this.state.selectedRowKeys[0]);
            }
        }
    }
    editClicked = () => {
        if (this.state.selectedRowKeys.length < 1 || this.props.data.length < 1) {
            alert(this.label("NoSelection"));
        } else {
            this.props.onEdit(this.state.selectedRowKeys[0]);
        }
    }
    viewClicked = () => {
        if (this.state.selectedRowKeys.length < 1 || this.props.data.length < 1) {
            alert(this.label("NoSelection"));
        } else {
            this.props.onView(this.state.selectedRowKeys[0]);
        }
    }
    refreshClicked = () => {
        this.props.onRefresh();
    }
    selectRow = (record, readonly) => {
        let selectedRowKeys = [];
        selectedRowKeys.push(record[this.props.keyfield]);
        this.setState({ selectedRowKeys });
        if (this.props.onSelect && !readonly) {
            this.props.onSelect(record[this.props.keyfield]);
        }
    }
    doubleClickRow = (record, readonly) => {
        let selectedRowKeys = [];
        selectedRowKeys.push(record[this.props.keyfield]);
        this.setState({ selectedRowKeys });
        if (this.props.onDoubleClick && !readonly) {
            this.props.onDoubleClick(record[this.props.keyfield]);
        }
    }
    onSelectedRowKeysChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
        if (this.props.onSelect) {
            this.props.onSelect(selectedRowKeys[0]);
        }
    }

    render() {

        let locale = {
            emptyText: (
              <span>
                <p>
                  <FileUnknownOutlined />
                  {this.label("NoData")}
                </p>
            </span>
            )
          };

        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            type: 'radio',
            onChange: this.onSelectedRowKeysChange,
        };
        let readonly = false;
        if (this.props.readOnly) {
            readonly = this.props.readOnly;
        }
        let multilineStyle ={};
        if (this.props.multiline) {
            multilineStyle = { whiteSpace: 'pre-line'};
        }
        return (
            <div>
                <div className="generiktable-actions">
                    {(this.props.onAdd && !readonly) &&
                        <Tooltip title={`${this.label("Add")} ${this.props.itemName}`}>
                            <Button type='primary' icon={<PlusOutlined />} onClick={this.addClicked} />
                        </Tooltip>
                    }
                    {(this.props.onDelete && !readonly) &&
                        <Tooltip title={`${this.label("Delete")} ${this.props.itemName}`}>
                            <Button type='primary' icon={<MinusOutlined />} onClick={this.deleteClicked} />
                        </Tooltip>
                    }
                    {(this.props.onEdit && !readonly) &&
                        <Tooltip title={`${this.label("Edit")} ${this.props.itemName}`}>
                            <Button type='primary' icon={<FormOutlined />} onClick={this.editClicked} />
                        </Tooltip>
                    }
                    {this.props.onView &&
                        <Tooltip title={`${this.label("View")} ${this.props.itemName}`}>
                            <Button type='primary' icon={<EyeOutlined />} onClick={this.viewClicked} />
                        </Tooltip>
                    }
                    {this.props.onRefresh &&
                        <Tooltip title={this.label("Refresh")}>
                            <Button type='primary' className='refreshbtn' icon={<ReloadOutlined />} onClick={this.refreshClicked} />
                        </Tooltip>
                    }
                </div>
                <Table style={multilineStyle} bordered={this.props.bordered} rowClassName={this.props.aligntop ? 'generiktable-col-aligntop' : ''} size='small' pagination={{ pageSize: this.props.pagesize ? this.props.pagesize : 5 }}
                    rowKey={record => record[this.props.keyfield]}
                    rowSelection={this.props.keyfield ? rowSelection : null}
                    columns={this.props.columns}
                    dataSource={this.props.data}
                    locale={locale}
                    onRow={(record) => ({
                        onClick: () => {
                            this.selectRow(record, readonly);
                        },
                        onDoubleClick: () => {
                            this.doubleClickRow(record, readonly);
                        },
                    })}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        labels : uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps, { })(GenericTable);  
